import * as React from "react";
const AppShellContext = React.createContext(null);
AppShellContext.displayName = "EleviaAppShellContext";
const AppShellProvider = AppShellContext.Provider;
function useAppShell() {
  return React.useContext(AppShellContext);
}
const PlacementContext = React.createContext("sidebar");
PlacementContext.displayName = "EleviaSidebarPlacement";
const SidebarPlacementProvider = PlacementContext.Provider;
function useSidebarPlacement() {
  return React.useContext(PlacementContext);
}
export {
  AppShellProvider,
  SidebarPlacementProvider,
  useAppShell,
  useSidebarPlacement
};
//# sourceMappingURL=ShellContext.js.map
